import React, { useEffect, } from "react";

import "../../../../../../components/customSelect/customSelect.css";

import { Button } from "reactstrap";

import { Controller, useFormContext, useFieldArray } from "react-hook-form";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import RHFTextInput from "../../../../../../components/form/RHFTextInput";
import RHFPhoneInput from "../../../../../../components/form/RHFPhoneInput";
import RHFSelect from "../../../../../../components/form/RHFSelect";
import { allCountries } from 'country-region-data'; // Import the raw data
import RHFCustomDatePicker from "../../../../../../components/form/RHFCustomDatePicker";


const titleOptions = [
  { label: "Mr", value: "Mr" },
  { label: "Ms", value: "Ms" },
  { label: "Mrs", value: "Mrs" },
];

const TravelerInformation = ({

  setActive
}) => {



  const { control, watch, setValue, formState: { errors }, trigger } = useFormContext();

  const mantineCountryList = allCountries
    .map((country) => country.countryName || country[0])
    .filter(Boolean);


  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "26px",
      backgroundColor: "#e8eef7",
      borderColor: state.isFocused ? " #e8eef7" : "#e8eef7",
      // boxShadow: state.isFocused ? "0 0 0 1px #1976d2" : "none",
      "&:hover": {
        borderColor: "#e8eef7",
      },
      padding: "8px 14px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#888",
      fontSize: "16px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      marginTop: "4px",
      zIndex: 9999, // fixes dropdown hiding behind other elements
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#e3f2fd" : "white",
      color: "#333",
      padding: "10px",
      cursor: "pointer",
    }),
  };

  const validateDateFormat = (value) => {
    const ddmmyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    // const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    if (ddmmyyyy.test(value)) {
      return true;
    }

    return "Date must be in mm-dd-yyyy format";
  };


  const handleNext = async () => {
    const isValid = await trigger([
      "personal_details",
      "travelers",
      // "from_country",
      // 'to_country'
    ]);

    if (!isValid) {
      return;
    }

    // console.log("first")

    setActive((current) => current + 1);
  }




  const parseAddressComponents = (components = []) => {
    const result = { city: "", state: "", postalCode: "", country: "" };

    components.forEach((c) => {
      if (c.types.includes("locality")) {
        result.city = c.long_name;
      }
      if (!result.city && c.types.includes("sublocality_level_1")) {
        result.city = c.long_name;
      }
      if (!result.city && c.types.includes("administrative_area_level_2")) {
        result.city = c.long_name;
      }

      if (c.types.includes("administrative_area_level_1")) {
        result.state = c.long_name;
      }
      if (c.types.includes("postal_code")) {
        result.postalCode = c.long_name;
      }
      if (c.types.includes("country")) {
        result.country = c.long_name;
      }
    });

    return result;
  };


  const buildStreetAddress = (components = [], placeName = "") => {
    const keepTypes = new Set([
      "street_number",
      "route",
      "subpremise",
      "premise",
      "sublocality_level_1",
      "sublocality",
      "neighborhood",
      "establishment",
      "natural_feature",
      "airport",
    ]);

    const excludeTypes = new Set([
      "locality",
      "administrative_area_level_1",
      "administrative_area_level_2",
      "administrative_area_level_3",
      "postal_code",
      "country",
    ]);

    // First strict pass: keep components that contain at least one keepTypes and do not contain any exclude types
    const streetParts = components
      .filter((c) => {
        if (c.types.some((t) => excludeTypes.has(t))) return false;
        return c.types.some((t) => keepTypes.has(t));
      })
      .map((c) => c.long_name);

    // If we have streetParts, attempt to join in a sensible order: street_number before route
    if (streetParts.length) {
      // Try to put street number before route
      const number = components.find((c) => c.types.includes("street_number"))?.long_name;
      const route = components.find((c) => c.types.includes("route"))?.long_name;
      if (number && route) return `${number} ${route}`;
      // otherwise return the joined streetParts (first 3 parts)
      return streetParts.slice(0, 3).join(", ");
    }

    // Loose fallback: exclude obvious admin/postal/country types and take first few parts
    const loose = components
      .filter((c) => !c.types.some((t) => excludeTypes.has(t)))
      .map((c) => c.long_name);

    if (loose.length) return loose.slice(0, 3).join(", ");

    // Use place's name (business or establishment) as last-resort
    if (placeName) return placeName;

    return "";
  };


  const onPlaceSelect_JS = (val) => {


    if (!val) {
      // clear related fields
      setValue("personal_details.city", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      setValue("personal_details.state", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      setValue("personal_details.postal_code", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });

      return;
    }

    // val.value might be a placeId or an object containing place_id
    let placeId = typeof val.value === "string" ? val.value : (val.value?.place_id || val.value?.placeId);
    if (!placeId && val?.place_id) placeId = val.place_id;

    const addressLabel = val.label || val.description || "";

    // Save a temporary address label while we fetch details
    // setValue('address', addressLabel, { shouldValidate: true, shouldDirty: true, shouldTouch: true });

    if (!window.google || !placeId) {
      // Google script not loaded (or not available) — keep the label but we can't refine components
      console.warn("Google script not loaded or missing placeId — cannot get address components.");
      return;
    }

    const ps = new window.google.maps.places.PlacesService(document.createElement("div"));

    ps.getDetails({ placeId, fields: ["address_components", "formatted_address", "name"] }, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
        const parsed = parseAddressComponents(place.address_components || []);

        // keep other fields if you still want them stored in the form
        setValue("personal_details.city", parsed?.city || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue("personal_details.state", parsed?.state || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue("personal_details.postal_code", parsed?.postalCode || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue("personal_details.nationality", parsed?.country || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });


        let streetAddress = buildStreetAddress(place.address_components || [], place.name || "");

        // If still empty, fallback to taking the first part(s) of formatted_address
        if (!streetAddress) {
          if (place.formatted_address) {
            // Take first segment(s) before locality/admin; naive split by comma
            const parts = place.formatted_address.split(",").map((p) => p.trim()).filter(Boolean);
            // prefer the first part (street line) only
            if (parts.length) streetAddress = parts[0];
          }
        }

        // Final fallback: use the label from autocomplete
        if (!streetAddress) streetAddress = addressLabel;

        setValue('personal_details.address', streetAddress || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      } else {
        console.error("getDetails failed:", status);
      }
    });
  };

  const travelers = watch("travelers");

  const isManual = watch('personal_details.is_manual')

  useEffect(() => {
    const num_of_passenger = (travelers?.length ?? 0) + 1 || 1;
    setValue('num_of_passenger', num_of_passenger)
  }, [travelers, setValue])


  const {
    fields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "travelers",
  });

  console.log(watch('personal_details'))



  return (
    <div className="stepper-container">

      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Traveler information
        </h3>
      </div>
      <div>
        <h4 className="stepper-sub-header" style={{ marginBottom: "5px" }}>
          How many passengers are included in this claim?
        </h4>
        <h6 className="sub-header" style={{ marginBottom: "15px" }}>
          Each passenger may be eligible for separate compensation.
        </h6>
        <div className="claim-grid">
          <RHFTextInput
            name="num_of_passenger"
            label="Number of Passengers"
            readOnly
            rules={{
              required: "Number of Passengers is required"
            }}

            withAsterisk
          />
        </div>
      </div>


      {/* <div>
        <h4 className="stepper-sub-header" style={{ marginTop: "15px" }}>
          Travel Route
        </h4>
       
        <div className="claim-grid">
          <RHFSelect
            name="from_country"
            label="From Country"
            searchable
            placeholder='Select country'

            withAsterisk
            rules={{
              required: "From country is required"
            }}

            data={mantineCountryList}
          />

          <RHFSelect
            name="to_country"
            label="To Country"
            searchable
            placeholder='Select country'
            withAsterisk
            rules={{
              required: "To country is required"
            }}

            data={mantineCountryList}
          />



        </div>
      </div> */}

      <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
        <div className="file-a-claim">
          <h4
            className="stepper-sub-header"
            style={{ marginBottom: "15px", marginTop: "30px" }}
          >
            First traveler details
          </h4>
          <h2
            className="stepper-sub-sub-header"
            style={{ marginBottom: "15px" }}
          >
            Personal details
          </h2>
          <div className="claim-grid">
            <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
              <div style={{ width: "115px", flexShrink: 0 }}>
                <RHFSelect
                  name="personal_details.name_prefix"
                  label="Title"
                  placeholder="Select"
                  data={titleOptions}
                  withAsterisk
                  rules={{
                    required: "Title is required",
                  }}
                />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <RHFTextInput
                  name="personal_details.last_name"
                  label="Last Name"
                  placeholder="Enter last name"
                  rules={{
                    required: "Last Name is required",
                  }}
                  capitalizeFirst
                  withAsterisk
                />
              </div>
            </div>

            <RHFTextInput
              name="personal_details.first_name"
              label="First Name"
              placeholder="Enter first name"
              rules={{
                required: "First Name is required",
              }}
              capitalizeFirst
              withAsterisk
            />

            <RHFCustomDatePicker
              name={`personal_details.date_of_birth`}

              withAsterisk
              label="Date of Birth"
              rules={{
                required: "Date of birth is required",
                validate: validateDateFormat,
              }}

            />



            <RHFPhoneInput
              name="personal_details.contact_no"
              label="Mobile Number"
              placeholder='Enter mobile number'
              withAsterisk
              onValueChange={(e) => {
                setValue('claim_id', e);
              }}
              maxLength={10}
              rules={{
                required: "Mobile Number is required",
                minLength: {
                  value: 10,
                  message: "Mobile Number must be 10 digits"
                }
              }}
            />

            <RHFTextInput
              name="personal_details.email_id"
              withAsterisk
              placeholder='Enter your email'
              label="Email"
              type="email"
              rules={{
                required: "Email is required"
              }}
            />
            <RHFTextInput
              name="personal_details.passport_number"
              withAsterisk
              placeholder='Enter passport number'
              label="Passport Number"
              rules={{
                required: "Passport Number is required"
              }}
            />
          </div>


          <h2
            className="stepper-sub-sub-header"
            style={{ marginBottom: "15px", marginTop: "30px" }}
          >
            Home address
          </h2>
          <div className="claim-grid">
            <div style={{ display: 'flex', gap: "10px" }} className="street-address-wrapper">
              <div className="custom-input" style={{ flex: 1, gap: '8px' }}>

                <label className="input-label">
                  Street address
                  <span style={{ color: "#de8385" }}> *</span>
                </label>


                {!isManual ? <Controller
                  name="personal_details.address"
                  control={control}
                  defaultValue={''}

                  rules={{ required: "Home Address is Required" }}
                  render={({ field }) => {

                    // Provide `value` as an object { label, value } expected by react-select
                    const value = field.value ? { label: field.value, value: field.value } : null;
                    return (


                      <GooglePlacesAutocomplete
                        {...field}
                        apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}
                        selectProps={{
                          value,
                          placeholder: "Search address...",
                          onChange: (val) => {
                            // val is { label, value }
                            const addr = val ? val.label : "";
                            // update react-hook-form field
                            field.onChange(addr);
                            // also update any other form state if needed
                            setValue("personal_details.address", addr, { shouldValidate: true });
                            onPlaceSelect_JS(val)
                          },
                          styles: selectStyles
                        }}
                      />)
                  }} /> : <Controller
                  name="personal_details.address"
                  control={control}
                  defaultValue={''}

                  rules={{ required: "Home Address is Required" }}
                  render={({ field }) => {

                    return <input
                      {...field}
                      className="input-box"
                      placeholder="Enter address"
                      type="text"
                    />
                  }} />}







                {errors.address && (
                  <p className="errormessage">{errors.address.message}</p>
                )}
              </div>

              <div className="custom-input unit-wrapper" style={{ gap: '8px' }}>
                <label className="input-label">
                  Unit

                </label>
                <Controller
                  name="personal_details.unit"
                  control={control}
                  defaultValue={''}

                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Unit"
                      type="text"
                    />
                  )}
                />

              </div>


            </div>



            <RHFTextInput
              name="personal_details.city"
              label="City"
              placeholder='Enter city'
              readOnly={!isManual}
              withAsterisk
              rules={{
                required: "City is required"
              }}

            />

            <RHFTextInput
              name="personal_details.state"
              label="State"
              placeholder='Enter state'

              withAsterisk
              rules={{
                required: "State is required"
              }}
              readOnly={!isManual}
            />
            <RHFTextInput
              name="personal_details.postal_code"
              label="ZIP/Postal Code"
              placeholder='Enter zip code'
              withAsterisk
              rules={{
                required: "Postal Code is required"
              }}
              readOnly={!isManual}
            />

            <RHFSelect
              name="personal_details.nationality"
              label="Nationality"
              placeholder='Select country'

              searchable
              withAsterisk
              rules={{
                required: "Nationality is required"
              }}
              readOnly={!isManual}
              data={mantineCountryList}
            />

            <div className="custom-select" style={{ gap: '8px' }}>
              <label className="input-label">Can’t find your address?</label>
              <button onClick={() => {

                setValue("personal_details.is_manual", true, {
                  shouldDirty: true,
                  shouldValidate: true,
                });
              }} className="btn btn-manual" type="button">Enter Manually</button>
            </div>
          </div>

          <h2
            className="stepper-sub-sub-header"
            style={{ marginBottom: "15px", marginTop: "30px" }}
          >
            Flight details
          </h2>
          <div className="claim-grid">
            <RHFTextInput
              name="personal_details.tickets"
              label="Ticket Number"
              placeholder='Enter ticket number'
              withAsterisk
              rules={{
                required: "Ticket Number is required",
                validate: (value) =>
                  value.length === 13 ||
                  "Ticket Number must be 13 digits"
              }}
            />
            <RHFTextInput
              name="personal_details.airline_res_no"
              label="Airline Reservation Number"
              placeholder="Enter reservation number"
              withAsterisk
              rules={{
                required: "Airline Reservation Number is required"
              }}
            />
          </div>
        </div>
        {fields.length > 0 && <>
          <h2
            className="stepper-sub-sub-header"
            style={{ marginBottom: "-15px", marginTop: "15px" }}
          >
            Additional Traveler Details
          </h2>


          {fields.map((member, index) => (
            <React.Fragment key={index} >

              <div className="col-12">
                <h4
                  className="stepper-sub-header"
                  style={{ marginBottom: "15px", marginTop: "15px" }}
                >
                  Traveler {index + 2}
                </h4>
                {/* First Name, Last Name, and Date Of Birth Fields */}
                <div
                  className="claim-grid"

                >
                  <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <div style={{ width: "115px", flexShrink: 0 }}>
                      <RHFSelect
                        name={`travelers.${index}.name_prefix`}
                        label="Title"
                        placeholder="Select"
                        data={titleOptions}
                        withAsterisk
                        rules={{
                          required: "Title is required",
                        }}
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <RHFTextInput
                        name={`travelers.${index}.last_name`}
                        label="Last Name"
                        withAsterisk
                        rules={{ required: "Last Name is required" }}
                        placeholder="Last Name"
                        capitalizeFirst
                      />
                    </div>
                  </div>
                  <RHFTextInput
                    name={`travelers.${index}.first_name`}
                    label="First Name"
                    withAsterisk
                    rules={{ required: "First Name is required" }}
                    placeholder="First Name"
                    capitalizeFirst
                  />

                  <RHFCustomDatePicker
                    name={`travelers.${index}.date_of_birth`}

                    withAsterisk
                    label="Date of Birth"
                    rules={{
                      required: "Date of birth is required",
                      validate: validateDateFormat,
                    }}

                  />

                  <RHFSelect
                    name={`travelers.${index}.country`}
                    label="Nationality"

                    withAsterisk
                    searchable
                    data={mantineCountryList}
                    rules={{ required: "Nationality is required" }}
                    placeholder="Select Country"
                  />

                  <RHFTextInput
                    name={`travelers.${index}.passport_number`}
                    label="Passport Number"
                    withAsterisk
                    rules={{ required: "Passport Number is required" }}
                    placeholder="Passport Number"
                  />
                  <RHFTextInput
                    name={`travelers.${index}.tickets`}
                    label="Ticket Number"
                    withAsterisk
                    rules={{ required: "Ticket Number is required" }}
                    placeholder="Ticket Number"
                  />

                  <RHFTextInput
                    name={`travelers.${index}.airline_res_no`}
                    label="Airline Reservation Number"
                    withAsterisk
                    rules={{ required: "Airline Reservation Number is required" }}
                    placeholder="Reservation Number"
                  />
                </div>


                {/* Remove Button */}
                <div className="row mt-3">
                  <div className="col-md-2">
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => remove(index)}
                      style={{ marginTop: "30px" }}
                    >
                      Remove
                    </Button>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))} </>}


        <div className="add-btn-wrapper" style={{ justifyContent: 'flex-end' }}>

          <button className="secondary-btn" type="button" onClick={() => append({})}>
            Add traveler
          </button>

          <button onClick={handleNext} className="primary-btn" type="button">
            Next
          </button>




        </div>


      </div>

    </div>
  );
};

export default TravelerInformation;
